// src/components/Services.js
import React from 'react';
import { FaBolt, FaWrench, FaHome, FaTools } from 'react-icons/fa';

const servicesData = [
    { id: 's-1', icon: <FaBolt />, title: 'Dépannage Électrique', description: 'Une urgence ? Intervention rapide et efficace pour toute panne électrique au Tampon et ses environs.' },
    { id: 's-2', icon: <FaWrench />, title: 'Installation & Rénovation', description: 'Mise aux normes, création de circuits, rénovation complète de vos installations pour plus de sécurité et de confort.' },
    { id: 's-3', icon: <FaHome />, title: 'Domotique', description: 'Rendez votre maison plus intelligente. Contrôle de l\'éclairage, des volets, de la piscine et plus encore.' },
    { id: 's-4', icon: <FaTools />, title: 'Multiservices', description: 'Un service complet incluant petits travaux, finitions et travail du bois pour parfaire vos projets.' }
];

const Services = () => {
    return (
        <section id="services" className="section">
            <h2 className="section-title">Mes Services</h2>
            <p className="section-subtitle">Artisan électricien pour tous vos besoins au Tampon et dans le Sud de La Réunion</p>
            <div className="services-grid">
                {servicesData.map(service => (
                    <div className="service-card" id={service.id} key={service.id}>
                        <div className="icon">{service.icon}</div>
                        <h3>{service.title}</h3>
                        <p>{service.description}</p>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default Services;